"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightsClient = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const authenticated_client_1 = require("./authenticated.client");
class InsightsClient extends authenticated_client_1.AuthenticatedClient {
    getDiscardedInsights(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v2/projects/${projectId}/users/me/insights/discarded`);
            return payload || [];
        });
    }
    updateDiscardedInsights(projectId, insights) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpPut(`/v2/projects/${projectId}/users/me/insights/discarded`, insights);
            return payload;
        });
    }
    getInsightsWithScoring(projectId, insightsRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpPost(`/v2/projects/${projectId}/insights/scoring`, Object.assign({ startDate: insightsRequest.from, endDate: insightsRequest.to }, (0, lodash_1.omit)(insightsRequest, ['from', 'to'])));
            return payload;
        });
    }
    getInsightsWithReplays(projectId, insightsRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const path = `/v2/projects/${projectId}/insights/session-replay/listPagesRecorded`;
            const { payload } = yield this.httpPost(path, insightsRequest);
            return payload;
        });
    }
}
exports.InsightsClient = InsightsClient;
//# sourceMappingURL=insights.client.js.map